import {
  INQUIRY_FF_BIDS_SET_FILTER,
  INQUIRY_FF_BIDS_APPLY_FILTER,
  INQUIRY_FF_BIDS_ENABLE_LOADING,
  INQUIRY_FF_SET_BID_MASTER_DATA,
  INQUIRY_FF_SET_BID_MASTER_LOAD_ERROR,
  INQUIRY_FF_BIDS_DISABLE_LOADING,
  INQUIRY_FF_SET_RECENT_BIDS,
  INQUIRY_FF_RECENT_BID_LOAD_ERROR,
  INQUIRY_FF_SET_RECENT_BID_PAGINATION,
  INQUIRY_FF_BIDS_RESET_FILTERS,
  INQUIRY_FF_BIDS_GET_ALL_BIDS,
  INQUIRY_FF_SET_INQUIRY_DETAIL_DATA,
  INQUIRY_FF_INQUIRY_DETAIL_LOAD_ERROR,
  INQUIRY_FF_CREATE_BID_SET_CHARGES,
  INQUIRY_FF_BID_CHARGES_LOADING,
  INQUIRY_FF_CREATE_BID_PAGE_FORM,
  INQUIRY_FF_ADD_NEW_CHARGE,
  INQUIRY_FF_SET_UPDATE_CHARGE_ENTITIES,
  INQUIRY_FF_RECENT_BID_LOADING,
  INQUIRY_FF_DELETE_CHARGE,
  INQUIRY_FF_BID_SET_INIT_CHARGE_DETAILS,
  INQUIRY_FF_ADD_RESET_DATA,
  INQUIRY_FF_SET_PORTS,
  INQUIRY_SET_LINKED_FFS_FOR_INQUIRY,
} from 'src/actions/constants';

const defaultState = {
  isLoading: false,
  allBidsForFF: [],
  recentBidsLoading: false,
  selectedFilters: {
    sortBy: 'transit_time',
    descendingOrder: false,
  },
  originPorts: [],
  destinationPorts: [],
  chargeDetails: {
    taxes: {},
    disabledCharges: {},
    currencies: {},
    unitCounts: {},
    prices: {},
    totalCounts: {},
    exchangeRates: {},
    names: {},
    totalDefault: {},
  },
  createBidData: {
    formValues: {},
    chargeLoading: false,
  },
  appliedFilters: {
    sortBy: 'transit_time',
    descendingOrder: false,
  },
  pagination: {
    nextOrPrev: 'first',
    currentPageNumber: 1,
    resultPerPage: 10,
    isNextPresent: false,
  },
  paginationCreateBid: {
    nextOrPrev: 'first',
    currentPageNumber: 1,
    resultPerPage: 5,
  },
  linkedFFsForInquiry: [],
};
export default function (state: any = defaultState, action) {
  switch (action.type) {
    case INQUIRY_SET_LINKED_FFS_FOR_INQUIRY: {
      return {
        ...state,
        linkedFFsForInquiry: action.data,
      };
    }
    case INQUIRY_FF_BIDS_GET_ALL_BIDS: {
      return {
        ...state,
        allBidsForFF: action.data.data.data,
        pagination: {
          ...state.pagination,
          currentPageNumber : action.data && action.data.currentPageNumber,
          isNextPresent: action.data && action.data.isNextPresent,
          lastItemIdNext: action.data && action.data.lastItemIdNext,
          lastItemIdPrev: action.data && action.data.lastItemIdPrev,
          lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext,
          lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev,
        },
      };
    }
    case INQUIRY_FF_SET_PORTS: {
      return {
        ...state,
        [action.data.setPortsOf]: action.data.ports,
      };
    }
    case INQUIRY_FF_SET_RECENT_BID_PAGINATION: {
      return {
        ...state,
        paginationCreateBid: {
          ...state.paginationCreateBid,
          ...action.data,
        },
      };
    }
    case INQUIRY_FF_ADD_RESET_DATA : {
      return defaultState;
    }
    case INQUIRY_FF_BIDS_RESET_FILTERS: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
        selectedFilters: defaultState.selectedFilters,
      };
    }
    case INQUIRY_FF_BIDS_SET_FILTER: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }
    case INQUIRY_FF_BIDS_APPLY_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...state.selectedFilters,
        },
      };
    }

    case INQUIRY_FF_BIDS_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case INQUIRY_FF_BIDS_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case INQUIRY_FF_SET_BID_MASTER_DATA: {
      return {
        ...state,
        bidMasterData: action.data,
      };
    }
    case INQUIRY_FF_SET_BID_MASTER_LOAD_ERROR: {
      return {
        ...state,
        errorMessage: action.data,
      };
    }
    case INQUIRY_FF_SET_RECENT_BIDS: {
      return {
        ...state,
        recentBidsLoading: false,
        createBidData: {
          ...state.createBidData,
          recentBids: action.data.data,
        },
        paginationCreateBid: {
          ...state.paginationCreateBid,
          nextOrPrev: action.data.nextOrPrev ? action.data.nextOrPrev : 'first',
          currentPageNumber: action.data.currentPageNumber ? action.data.currentPageNumber : 1,
          isNextPresent: action.data.isNextPresent ? action.data.isNextPresent : false,
          lastItemIdNext: action.data.lastItemIdNext ? action.data.lastItemIdNext : 0,
          lastItemIdPrev: action.data.lastItemIdPrev ? action.data.lastItemIdPrev : 0,
          lastSortedColumnValueNext: action.data.lastSortedColumnValueNext ?
            action.data.lastSortedColumnValueNext : 0,
          lastSortedColumnValuePrev: action.data.lastSortedColumnValuePrev ?
            action.data.lastSortedColumnValuePrev : 0,
        },
      };
    }
    case INQUIRY_FF_RECENT_BID_LOAD_ERROR: {
      return {
        ...state,
        recentBidsLoading: false,
        errorMessage: action.data,
      };
    }
    case INQUIRY_FF_SET_INQUIRY_DETAIL_DATA: {
      return {
        ...state,
        createBidData: {
          ...state.createBidData,
          inquiryData: action.data,
        },
      };
    }
    case INQUIRY_FF_INQUIRY_DETAIL_LOAD_ERROR: {
      return {
        ...state,
        createBidData: {
          ...state.createBidData,
          errorMessage: action.data,
        },
      };
    }
    case INQUIRY_FF_CREATE_BID_SET_CHARGES: {
      return {
        ...state,
        createBidData: {
          ...state.createBidData,
          bidCharges: action.data,
        },
      };
    }
    case INQUIRY_FF_BID_CHARGES_LOADING: {
      return {
        ...state,
        createBidData: {
          ...state.createBidData,
          chargeLoading: action.data,
        },
      };
    }
    case INQUIRY_FF_CREATE_BID_PAGE_FORM: {
      return {
        ...state,
        createBidData: {
          ...state.createBidData,
          formValues: {
            ...state.createBidData.formValues,
            ...action.data,
          },
        },
      };
    }
    case INQUIRY_FF_ADD_NEW_CHARGE: {
      return {
        ...state,
        createBidData: {
          ...state.createBidData,
          bidCharges: {
            ...state.createBidData.bidCharges,
            [action.data.key]: {
              ...state.createBidData.bidCharges[action.data.key],
              values: [...state.createBidData.bidCharges[action.data.key].values, {
                isNewCharge: true,
                nameNotSet: true,
                key: action.data.chargeKey,
                category: action.data.category,
                name: action.data.value,
              }],
            },
          },
        },
      };
    }
    case INQUIRY_FF_BID_SET_INIT_CHARGE_DETAILS: {
      return {
        ...state,
        chargeDetails: action.data,
      };
    }
    case INQUIRY_FF_SET_UPDATE_CHARGE_ENTITIES: {
      return {
        ...state,
        chargeDetails: {
          ...state.chargeDetails,
          [action.data.item]: {
            ...state.chargeDetails[action.data.item],
            [action.data.key]: action.data.val,
          },
        },
      };
    }
    case INQUIRY_FF_RECENT_BID_LOADING: {
      return {
        ...state,
        recentBidsLoading: true,
      };
    }
    case INQUIRY_FF_DELETE_CHARGE: {
      return {
        ...state,
        createBidData: {
          ...state.createBidData,
          bidCharges: {
            ...state.createBidData.bidCharges,
            [action.data.key]: {
              ...state.createBidData.bidCharges[action.data.key],
              values: action.data.values,
            },
          },
        },
      };
    }
    default: return state;
  }
}
